import React from 'react';
import PropTypes from 'prop-types';

const Radio = props => {
	return (
		<div className={`radio-control-wrap${props.defaultValue == props.input.value ? ' active' : ''}`}>
			<div className="radio-control">
				<input type="radio"
					{...props.input}
					id={props.input.name + props.defaultValue}
					checked={props.defaultValue == props.input.value}
					disabled={props.shouldDisable}
					onChange={() => {
						props.input.onChange(props.defaultValue);
					} }
				/>
				<label htmlFor={props.input.name + props.defaultValue} />
			</div>
			{ props.labelText && (
				<label htmlFor={props.input.name + props.defaultValue} className="label-name font-proxima-nova-regular">
					{props.labelText}
				</label>
			) }
		</div>
	);
};

Radio.propTypes = {
	input: PropTypes.object,
	shouldDisable: PropTypes.bool,
	defaultValue: PropTypes.string,
	labelText: PropTypes.string
};

export default Radio;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/display-type/radio-field.js